import "core-js/modules/es.array.map";

/*
 * Copyright (c) 2020 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
*/
import React from 'react';
import Block from 'wfui-digital-core/es/Block';
import Links from '../links/Links';
import styles from './Sections.less';

var SectionHeading = function SectionHeading(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(Block, {
    pt: "b",
    pb: "xs",
    pl: "b",
    role: "heading",
    "aria-level": 2,
    className: styles.heading
  }, children);
};

var Section = function Section(_ref2) {
  var section = _ref2.section;
  return /*#__PURE__*/React.createElement(Block, null, /*#__PURE__*/React.createElement(SectionHeading, null, section.label), /*#__PURE__*/React.createElement(Links, {
    links: section.links
  }));
};

var Sections = function Sections(_ref3) {
  var sections = _ref3.sections;
  return /*#__PURE__*/React.createElement(Block, {
    className: styles.sections
  }, sections.map(function (section, index) {
    return /*#__PURE__*/React.createElement(Section, {
      key: index,
      section: section
    });
  }));
};

export default Sections;